import { MapPin } from "lucide-react";
import { absUrl } from "./blocks/media";

// Standard venue header for map popups / venue lists: name + address left, logo right.
export const VenuePopupHeader = ({ venue, meta, compact = false, testId = "venue-popup-header" }) => {
  const address = [venue.address, venue.city, venue.state].filter(Boolean).join(", ");
  return (
    <div className="flex items-start justify-between gap-3 mb-2" data-testid={testId}>
      <div className="flex-1 min-w-0">
        <h3 className={`font-bold ${compact ? "text-[15px] font-semibold" : "text-[15px]"} text-[#1A1A1A] m-0 leading-tight`}>
          {venue.venue_name || "Venue TBD"}
          {meta}
        </h3>
        {address && (
          <p className={`${compact ? "text-xs text-[#9C9C9C]" : "text-[11px] text-[#5C5C5C]"} m-0 mt-0.5 flex items-center gap-1`}>
            {compact && <MapPin className="h-3 w-3 flex-shrink-0" />}
            <span className="truncate">{address}</span>
          </p>
        )}
      </div>
      {venue.logo_url && (
        <img
          src={absUrl(venue.logo_url)}
          alt={`${venue.venue_name} logo`}
          className="w-12 h-12 rounded-full object-cover border border-[#1A1A1A]/15 bg-white flex-shrink-0"
          loading="lazy"
          data-testid={`${testId}-logo`}
        />
      )}
    </div>
  );
};
